import React from 'react'
import { TextField } from '@mui/material'
import type { TextFieldProps } from '@mui/material'
import FieldLabel from './FieldLabel'

export type LabeledTextFieldProps = Omit<TextFieldProps, 'label'> & {
  /** Caption rendered above the input (label-at-top convention). */
  label: React.ReactNode
  /** Append a ` *` marker to the label. */
  required?: boolean
}

/**
 * A `FieldLabel` (label-at-top) paired with an MUI `TextField`. The standard
 * admin add/edit text input - use instead of a floating-label `TextField`.
 * All other `TextField` props (value, onChange, helperText, multiline, type,
 * InputProps, …) pass straight through; `fullWidth` defaults on.
 */
const LabeledTextField: React.FC<LabeledTextFieldProps> = ({
  label,
  required = false,
  fullWidth = true,
  ...textFieldProps
}) => (
  <>
    <FieldLabel required={required}>{label}</FieldLabel>
    <TextField fullWidth={fullWidth} {...textFieldProps} />
  </>
)

export default LabeledTextField
